"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickAdvertisementEditorSaveSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickAdvertisementEditorSaveSchema extends baseClickSchema_1.BaseClickSchema {
    constructor({ path, productId }) {
        super({ componentName: 'FreeModuleModalSaveButton' });
        this.action = baseSchema_1.ActionsName.CLICK_CREATE_AD;
        this.path = path;
        this.productId = productId || 0;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            pathUrl: this.path,
            productId: this.productId
        };
    }
}
exports.ClickAdvertisementEditorSaveSchema = ClickAdvertisementEditorSaveSchema;
